module.exports = __webpack_public_path__ + "img/expense.0a0bf8a3.png";